import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Something went wrong',
  description: 'Please report the problem to our developer team so they can look into it.',
  buttonTitle: 'Report',
  reload: 'Reload',
});
